import './Template.scss';

import React, { useEffect, useMemo, useState } from 'react';

import AdminBottomNav from './AdminBottomNav';
import NavbarTop from './NavbarTop';
import { Outlet } from 'react-router-dom';
import { Provider } from 'react-redux'
import SpaceMenuBottom from '../commons/SpaceMenuBottom';
import { ToastContainer } from 'react-toastify';
import UserService from '../auth/UserService';
import store from '../redux/store';
import { useRuntime } from '../commons/runtime/RuntimeContext';

const service = new UserService();

const Template = () => {
    const [userLogged, setUserLogged] = useState(null);
    const [hideAdminNav, setHideAdminNav] = useState(false);
    const { isFlutterWebView } = useRuntime();

    useEffect(() => {
        const user = service.getUserData();
        setUserLogged(user);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const docHeight = document.documentElement.scrollHeight;

            // distância do final (px)
            const distanceFromBottom = docHeight - (scrollTop + windowHeight);

            // se estiver a menos de 120px do final, esconde
            setHideAdminNav(distanceFromBottom < 120);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });

        // roda uma vez ao montar
        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const isAdmin = useMemo(() => {
        return userLogged?.rules?.length > 0 && userLogged.rules.includes('COMPANY');
    }, [userLogged]);


    return (
        <Provider store={store}>
            <div>
                {!isFlutterWebView && <NavbarTop />}
                <div className="container-pages">
                    <Outlet />
                    <ToastContainer />
                </div>
                {isAdmin && (
                    <>
                        <SpaceMenuBottom />
                        {!isFlutterWebView && isAdmin && (
                            <>
                                <SpaceMenuBottom />
                                {!hideAdminNav && <AdminBottomNav />}
                            </>
                        )}
                    </>
                )}
            </div>
        </Provider>

    );
};

export default Template;